<template>
  <footer>
    <b-container>
      <!-- <b-navbar variant="faded" type="light">
        <b-navbar-brand href="#"><Logo /></b-navbar-brand>
        <b-link class="help-link ml-md-auto">Help ?</b-link>
      </b-navbar> -->
      <b-navbar variant="faded" type="light">
        <p class="mb-0 mt-2 mt-md-0 copy">
          Copyright © {{ new Date().getFullYear() }} Techgentsia Software
          Technologies Pvt. Ltd.
        </p>
        <div class="ml-md-auto">
          <b-link
            class="help-link"
            href="https://techgentsia.com/#contact"
            target="_blank"
            >Contact</b-link
          >
          <!-- <b-link class="help-link">About Us</b-link> -->
          <!-- <b-link class="help-link">FAQ</b-link>
          <b-link class="help-link">Support</b-link> -->
        </div>
      </b-navbar>
    </b-container>
  </footer>
</template>

<script>
// import Logo from "./logo.vue";
export default {
  name: "FooterTemplate",
  // components: {
  //   Logo
  // }
};
</script>
